import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  getFormatDateFromStoreDate,
  RadioOptionsWithConfirm,
  SelectWithOtherWithConfirm,
  TextareaWithConfirm,
  YearInputWithConfirm,
  CardContainer,
  CardWithModal,
} from 'shared-components';
import { CourseLevel } from 'types';
import { getPreviousStudyVisaLabelFromValue, successfullyCompletedCourses } from 'data';

import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { IImportData, InputFieldConfig, IStudentVisa } from '../../../../types';
import { saveHistory } from '../../../../store/student/actions';
import { createUpdateHistoryFieldAction } from '../../../../store/student/history/actions';
import { Pages } from '../../../../store/student/history/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

import Visas from './visas';
import { useTranslation } from "react-i18next";

export interface IProps {
  sectionTitle: string;
  complete: boolean;
  currentStep: number;
  steps: number;

  lastCourse: string;
  lastCourseVisible: boolean;
  lastCourseConfig: InputFieldConfig;
  lastCourseOther: string;
  lastCourseOtherVisible: boolean;
  lastCourseOtherConfig: InputFieldConfig;
  lastCourseYear: string;
  lastCourseYearVisible: boolean;
  lastCourseYearConfig: InputFieldConfig;

  hasOverseasTravel?: boolean;
  hasOverseasTravelVisible: boolean;
  hasOverseasTravelConfig: InputFieldConfig;
  overseasTravelTimes: string;
  overseasTravelTimesVisible: boolean;
  overseasTravelTimesConfig: InputFieldConfig;
  hasUkTravel?: boolean;
  hasUkTravelVisible: boolean;
  hasUkTravelConfig: InputFieldConfig;
  ukTravelTimes?: string;
  ukTravelTimesVisible: boolean;
  ukTravelTimesConfig: InputFieldConfig;

  hasPreviousUkStudyVisa?: boolean;
  hasPreviousUkStudyVisaVisible: boolean;
  hasPreviousUkStudyVisaConfig: InputFieldConfig;
  hasPreviousUkStudy?: boolean;
  hasPreviousUkStudyVisible: boolean;
  hasPreviousUkStudyConfig: InputFieldConfig;

  lastCourseLevel?: CourseLevel;
  lastCourseLevelVisible: boolean;
  lastCourseLevelConfig: InputFieldConfig;
  lowerOrSameLevelReason?: string;
  lowerOrSameLevelReasonVisible: boolean;
  lowerOrSameLevelReasonConfig: InputFieldConfig;

  previousUkStudyVisas: Array<IStudentVisa>;
  config: any;
  isPageComplete?: boolean;
  importData: IImportData;
}

type Props = IProps;

interface ICardItem {
  value: string;
  label: string;
}

const HistoryQPage1 = (props: Props) => {
    const { t } = useTranslation('common');
  const getImportApprovedFields = (): Array<Q> => {
    const importApproved = [];
    if (props.isPageComplete) {
      if (props.importData.prevUKStudy === props.hasPreviousUkStudy) {
        importApproved.push(Q.HAS_PREVIOUS_UK_STUDY);
      }
    }
    return importApproved;
  };
  const getImportUpdateFields = (): Array<Q> => {
    const importUpdateEnabled = [];
    if (props.isPageComplete) {
      if (props.importData.prevUKStudy !== undefined && props.hasPreviousUkStudy !== props.importData.prevUKStudy) {
        importUpdateEnabled.push(Q.HAS_PREVIOUS_UK_STUDY);
      }
    }
    return importUpdateEnabled;
  };
  const [state, setState] = useState({
    showLastCourseYear: false,
    showPrevUKStudyVisaIndex: 0,
    showModal: [],
    lastCourse: props.lastCourse,
    lastCourseOther: props.lastCourseOther,
    lastCourseYear: props.lastCourseYear,
    hasOverseasTravel: props.hasOverseasTravel,
    overseasTravelTimes: props.overseasTravelTimes,
    hasUkTravel: props.hasUkTravel,
    ukTravelTimes: props.ukTravelTimes,
    hasPreviousUkStudyVisa: props.hasPreviousUkStudyVisa,
    hasPreviousUkStudy: props.hasPreviousUkStudy,
    lastCourseLevel: props.lastCourseLevel,
    lowerOrSameLevelReason: props.lowerOrSameLevelReason,
    importApproved: getImportApprovedFields(),
    importUpdateEnabled: getImportUpdateFields(),
    importEdited: [],
    previousUkStudyVisas: [
      ...(props.previousUkStudyVisas?.length ? props.previousUkStudyVisas : []),
      { visaType: '', level: '', year: '', isComplete: undefined },
    ],
  });

  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(saveHistory(Pages.PAGE1, config));

  const onChange = (fieldName: string, value: any, documentBlacklist?: Array<string>) =>
    dispatch(createUpdateHistoryFieldAction(fieldName, value, documentBlacklist));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  // TODO: refactor this
  useEffect(() => {
    if (JSON.stringify(state.previousUkStudyVisas) !== JSON.stringify(props.previousUkStudyVisas)) {
      setState(prevState => ({
        ...prevState,
        previousUkStudyVisas: [
          ...(props.previousUkStudyVisas?.length ? props.previousUkStudyVisas : []),
          { visaType: '', level: '', year: '', isComplete: undefined },
        ],
        showModal: [...props.previousUkStudyVisas.map(_ => false), false],
      }));
    }
  }, [props.previousUkStudyVisas]);

  // getImportApprovedFields = (): Array<Q> => {
  //   const importApproved = [];
  //   if (props.isPageComplete) {
  //     if (props.importData.prevUKStudy === this.props.hasPreviousUkStudy) {
  //       importApproved.push(Q.HAS_PREVIOUS_UK_STUDY);
  //     }
  //   }
  //   return importApproved;
  // };

  // getImportUpdateFields = (): Array<Q> => {
  //   const importUpdateEnabled = [];
  //   if (this.props.isPageComplete) {
  //     if (
  //       this.props.importData.prevUKStudy !== undefined &&
  //       this.props.hasPreviousUkStudy !== this.props.importData.prevUKStudy
  //     ) {
  //       importUpdateEnabled.push(Q.HAS_PREVIOUS_UK_STUDY);
  //     }
  //   }
  //   return importUpdateEnabled;
  // };

  const isImportEnabled = (target: Q | string): boolean => {
    switch (target) {
      case Q.HAS_PREVIOUS_UK_STUDY:
        return props.hasPreviousUkStudyVisible && props.importData.prevUKStudy !== undefined;
      default:
        return false;
    }
  };

  const isImportUpdateEnabled = (target: Q | string): boolean => {
    if (!props.isPageComplete) return false;
    switch (target) {
      case Q.HAS_PREVIOUS_UK_STUDY:
        return props.hasPreviousUkStudy !== undefined && state.importUpdateEnabled.includes(target);

      default:
        return false;
    }
  };

  const isImportComplete = (target: Q): boolean => {
    if (!isImportEnabled(target) || isImportUpdateEnabled(target)) return true;
    return state.importApproved.includes(target) || state.importEdited.includes(target);
  };

  const getComplete = (): boolean => {
    const importQuestions = [Q.SURNAME, Q.GIVEN_NAME];
    const importComplete = importQuestions.every(q => isImportComplete(q));
    return props.complete && importComplete;
  };

  const handleImportApprove = (target: Q | string): void => {
    setState(prevState => ({
      ...prevState,
      importApproved: [...prevState.importApproved, target as Q],
      importEdited: prevState.importEdited.filter(q => q !== target),
    }));
  };

  const handleImportEdit = (target: Q | string): void => {
    setState(prevState => ({
      ...prevState,
      importApproved: prevState.importApproved.filter(q => q !== target),
      importEdited: [...prevState.importEdited, target],
    }));
  };

  const handleImportUndo = (target: Q): void => {
    setState(prevState => ({
      ...prevState,
      importApproved: prevState.importApproved.filter(q => q !== target),
      importEdited: prevState.importEdited.filter(q => q !== target),
    }));
  };

  const handleYesNoClick = (target: Q, question: any) => {
    onChange(target, question.char === 'Y');
  };

  const handleOTTClick = (question: any) => {
    onChange(
      Q.OVERSEAS_TRAVEL_TIMES,
      question.char === '1' ? 'Once' : question.char === '2' ? 'Less than 5' : '5 or more',
    );
  };

  const handleUKTTClick = (question: any) => {
    onChange(Q.UK_TRAVEL_TIMES, question.char === '1' ? 'Once' : question.char === '2' ? 'Less than 5' : '5 or more');
  };

  const handleLastCourseLevelClick = (question: any) => {
    onChange(
      Q.LAST_COURSE_LEVEL,
      question.char === '1'
        ? CourseLevel.HIGHER
        : question.char === '2'
          ? CourseLevel.SAME
          : question.char === '3'
            ? CourseLevel.LOWER
            : CourseLevel.NO_UK_STUDY,
    );
  };

  const toggleModal = (index: number) => {
    setState(prevState => {
      const newShowModal = [...prevState.showModal];
      newShowModal[index] = !prevState.showModal[index];
      return {
        ...prevState,
        showModal: newShowModal,
      };
    });
  };

  const deleteVisa = (index: number): void => {
    const previousUkStudyVisas = [...props.previousUkStudyVisas];

    onChange(Q.PREVIOUS_UK_VISAS, [...previousUkStudyVisas.slice(0, index), ...previousUkStudyVisas.slice(index + 1)]);
  };

  const getVisaItems = (visa: IStudentVisa): Array<ICardItem> => {
    let cardItems = [
      {
        label: 'Study Level',
        value: visa.level,
      },
      {
        label: 'Year',
        value: visa.year,
      },
      {
        label: 'Completed',
        value: visa.isComplete ? 'Yes' : 'No',
      },
    ];
    if (!visa.isComplete) {
      cardItems = [
        ...cardItems,
        {
          label: 'Incomplete Reason',
          value: visa.incompleteReason ? visa.incompleteReason : '',
        },
        {
          label: 'Incomplete Record',
          value: visa.isIncompleteRecorded ? 'Yes' : 'No',
        },
        {
          label: 'Is Visa Shortened',
          value: visa.isVisaShortened ? 'Yes' : 'No',
        },
      ];
      if (visa.isVisaShortened) {
        cardItems = [
          ...cardItems,
          {
            label: 'Visa Shortened To',
            value: `${getFormatDateFromStoreDate(visa.shortenedDate)}`,
          },
        ];
      }
    }
    if (visa) {
      return cardItems;
    }
    return cardItems;
  };

  return (
    <QuestionPage
      complete={getComplete()}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      {props.lastCourseVisible && (
        <SelectWithOtherWithConfirm
          key={Q.LAST_COURSE}
          id={Q.LAST_COURSE}
          label={t('common:whatWasTheLastCourseYouSuccessfu')}
          autoFocus={true}
          options={successfullyCompletedCourses}
          otherOptions={[
            {
              label: 'Other',
              value: 'Other',
            },
          ]}
          otherOptionLabel="Please state why you chose other:"
          value={props.lastCourse}
          onChange={(evt: any) => onChange(Q.LAST_COURSE, evt.currentTarget.value)}
          onChangeOtherText={(evt: any) => onChange(Q.LAST_COURSE_OTHER, evt.currentTarget.value)}
          inputHelperText={props.lastCourseConfig?.helpText}
          otherValue={props.lastCourseOther}
        />
      )}

      {props.lastCourseYearVisible && (
        <YearInputWithConfirm
          key={Q.LAST_COURSE_YEAR}
          id={Q.LAST_COURSE_YEAR}
          value={props.lastCourseYear}
          label={t('common:inWhichYearDidYouCompleteThisCou')}
          inputHelperText={props.lastCourseYearConfig?.helpText}
          onChange={(evt: any) => onChange(Q.LAST_COURSE_YEAR, evt.currentTarget.value)}
          maxLength={4}
          placeholder={t('common:yyyy')}
        />
      )}

      {props.hasOverseasTravelVisible && (
        <RadioOptionsWithConfirm
          key={Q.HAS_OVERSEAS_TRAVEL}
          id={Q.HAS_OVERSEAS_TRAVEL}
          label={t('common:haveYouEverTravelledOutsideOfYou')}
          inputHelperText={props.hasOverseasTravelConfig?.helpText}
          onClick={(question: any) => handleYesNoClick(Q.HAS_OVERSEAS_TRAVEL, question)}
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasOverseasTravel === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasOverseasTravel === false,
            },
          ]}
        />
      )}

      {props.overseasTravelTimesVisible && (
        <RadioOptionsWithConfirm
          key={Q.OVERSEAS_TRAVEL_TIMES}
          id={Q.OVERSEAS_TRAVEL_TIMES}
          value={props.overseasTravelTimes}
          label={t('common:approximatelyHowManyTimes')}
          inputHelperText={props.overseasTravelTimesConfig?.helpText}
          onClick={(question: any) => handleOTTClick(question)}
          questions={[
            {
              char: '1',
              label: 'Once',
              selected: props.overseasTravelTimes === 'Once',
            },
            {
              char: '2',
              label: 'Less than 5',
              selected: props.overseasTravelTimes === 'Less than 5',
            },
            {
              char: '3',
              label: '5 or more',
              selected: props.overseasTravelTimes === '5 or more',
            },
          ]}
        />
      )}

      {props.hasUkTravelVisible && (
        <RadioOptionsWithConfirm
          key={Q.HAS_UK_TRAVEL}
          id={Q.HAS_UK_TRAVEL}
          value={props.hasUkTravel}
          label={t('common:haveYouEverTravelledToTheUkInThe')}
          inputHelperText={props.hasUkTravelConfig?.helpText}
          onClick={(question: any) => handleYesNoClick(Q.HAS_UK_TRAVEL, question)}
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasUkTravel === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasUkTravel === false,
            },
          ]}
        />
      )}

      {props.ukTravelTimesVisible && (
        <RadioOptionsWithConfirm
          key={Q.UK_TRAVEL_TIMES}
          id={Q.UK_TRAVEL_TIMES}
          value={props.ukTravelTimes}
          label={t('common:approximatelyHowManyTimes')}
          inputHelperText={props.ukTravelTimesConfig?.helpText}
          onClick={(question: any) => handleUKTTClick(question)}
          questions={[
            {
              char: '1',
              label: 'Once',
              selected: props.ukTravelTimes === 'Once',
            },
            {
              char: '2',
              label: 'Less than 5',
              selected: props.ukTravelTimes === 'Less than 5',
            },
            {
              char: '3',
              label: '5 or more',
              selected: props.ukTravelTimes === '5 or more',
            },
          ]}
        />
      )}

      {props.hasPreviousUkStudyVisible && (
        <RadioOptionsWithConfirm
          key={Q.HAS_PREVIOUS_UK_STUDY}
          id={Q.HAS_PREVIOUS_UK_STUDY}
          label={t('common:doYouHaveAnyPreviousUkStudy')}
          inputHelperText={props.hasPreviousUkStudyConfig?.helpText}
          onClick={(question: any) => handleYesNoClick(Q.HAS_PREVIOUS_UK_STUDY, question)}
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasPreviousUkStudy === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasPreviousUkStudy === false,
            },
          ]}
          importEnabled={isImportEnabled(Q.HAS_PREVIOUS_UK_STUDY)}
          importValue={props.importData.prevUKStudy ? 'Yes' : 'No'}
          importUpdateEnabled={isImportUpdateEnabled(Q.HAS_PREVIOUS_UK_STUDY)}
          importApproved={state.importApproved.includes(Q.HAS_PREVIOUS_UK_STUDY)}
          importEdited={state.importEdited.includes(Q.HAS_PREVIOUS_UK_STUDY)}
          onImportApprove={() => {
            handleImportApprove(Q.HAS_PREVIOUS_UK_STUDY);
            onChange(Q.HAS_PREVIOUS_UK_STUDY, props.importData.prevUKStudy);
          }}
          onImportEdit={() => {
            handleImportEdit(Q.HAS_PREVIOUS_UK_STUDY);
            onChange(
              Q.HAS_PREVIOUS_UK_STUDY,
              isImportUpdateEnabled(Q.HAS_PREVIOUS_UK_STUDY) ? props.hasPreviousUkStudy : props.importData.prevUKStudy,
            );
          }}
          onImportUndo={() => {
            handleImportUndo(Q.HAS_PREVIOUS_UK_STUDY);
            onChange(
              Q.HAS_PREVIOUS_UK_STUDY,
              isImportUpdateEnabled(Q.HAS_PREVIOUS_UK_STUDY) ? state.hasPreviousUkStudy : '',
            );
          }}
        />
      )}
      {props.hasPreviousUkStudy && (
        <>
          <RadioOptionsWithConfirm
            key={Q.HAS_PREVIOUS_UK_STUDY_VISA}
            id={Q.HAS_PREVIOUS_UK_STUDY_VISA}
            label={t('common:didYouReceiveAStudentVisaForYour')}
            inputHelperText={props.hasPreviousUkStudyVisaConfig?.helpText}
            onClick={(question: any) => handleYesNoClick(Q.HAS_PREVIOUS_UK_STUDY_VISA, question)}
            isInline={true}
            questions={[
              {
                char: 'Y',
                label: 'Yes',
                selected: props.hasPreviousUkStudyVisa === true,
              },
              {
                char: 'N',
                label: 'No',
                selected: props.hasPreviousUkStudyVisa === false,
              },
            ]}
          />

          {props.hasPreviousUkStudyVisa && (
            <>
              <CardContainer title={t('common:ukStudentVisas')}>
                {state.previousUkStudyVisas.map((visa: IStudentVisa, index: number) => (
                  <CardWithModal
                    key={index}
                    id={`visa-${index}`}
                    index={index}
                    modalTitle={'Add a UK Student Visa'}
                    cardTitle={getPreviousStudyVisaLabelFromValue(visa.visaType)}
                    cardItems={getVisaItems(visa)}
                    onRemove={deleteVisa}
                    addButtonLabel={`Add Previous UK VISA`}
                    addAnotherButtonLabel={`I have another visa to add`}
                    hasAddMoreButton={
                      visa.visaType === '' && visa.level === '' && visa.year === '' && visa.isComplete === undefined
                    }
                    showModal={state.showModal[index]}
                    toggleModal={toggleModal}
                  >
                    <Visas
                      index={index}
                      visaType={visa.visaType}
                      level={visa.level}
                      year={visa.year}
                      isComplete={visa.isComplete}
                      incompleteReason={visa.incompleteReason}
                      isIncompleteRecorded={visa.isIncompleteRecorded}
                      isVisaShortened={visa.isVisaShortened}
                      shortenedDate={visa.shortenedDate}
                      onSaveAndClose={(visa: IStudentVisa) => {
                        const previousUkStudyVisas = [...props.previousUkStudyVisas];
                        previousUkStudyVisas[index] = {
                          ...visa,
                        };
                        onChange(Q.PREVIOUS_UK_VISAS, previousUkStudyVisas);
                        toggleModal(index);
                      }}
                    />
                  </CardWithModal>
                ))}
              </CardContainer>

              {props.lastCourseLevelVisible && (
                <>
                  <RadioOptionsWithConfirm
                    key={Q.LAST_COURSE_LEVEL}
                    id={Q.LAST_COURSE_LEVEL}
                    value={props.lastCourseLevel}
                    label={
                      'Are you applying for a course that is at a higher, ' +
                      'same or lower-level than the last course you studied in the UK?'
                    }
                    inputHelperText={props.lastCourseLevelConfig?.helpText}
                    onClick={(question: any) => handleLastCourseLevelClick(question)}
                    questions={[
                      {
                        char: '1',
                        label: 'The course I am applying for now is at a higher level',
                        selected: props.lastCourseLevel === CourseLevel.HIGHER,
                      },
                      {
                        char: '2',
                        label: 'The course I am applying for now is at the same level',
                        selected: props.lastCourseLevel === CourseLevel.SAME,
                      },
                      {
                        char: '3',
                        label: 'The course I am applying for now is at a lower level',
                        selected: props.lastCourseLevel === CourseLevel.LOWER,
                      },
                      {
                        char: '4',
                        label: 'I have not studied any academic courses in the UK',
                        selected: props.lastCourseLevel === CourseLevel.NO_UK_STUDY,
                      },
                    ]}
                  />
                </>
              )}

              {props.lowerOrSameLevelReasonVisible && (
                <TextareaWithConfirm
                  id={Q.REASON_WHY_LOWER_OR_SAME_LEVEL}
                  value={props.lowerOrSameLevelReason}
                  label={
                    'Why are you applying for a course at the same or lower level as your previous course? ' +
                    'Please explain how will this course support your genuine career aspirations.'
                  }
                  onChange={(evt: any) => onChange(Q.REASON_WHY_LOWER_OR_SAME_LEVEL, evt.currentTarget.value)}
                />
              )}
            </>
          )}
        </>
      )}
    </QuestionPage>
  );
};
export default HistoryQPage1;
